module.exports = __webpack_public_path__ + "img/shape-rectangle.e08a0ebf.svg";